import { IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonItem, IonGrid, IonRow, IonCol } from '@ionic/react'
import React from 'react'

interface Props {
  texto?: string;
  children?: React.ReactNode;
}

export default function Cabecalho({ texto, children }: Props) {
  return (
    <IonHeader>
      <IonToolbar>
        <IonButtons slot="start">
          <IonMenuButton />
        </IonButtons>
        <IonItem>
          <IonGrid>
            <IonRow class="ion-align-items-center">
              <IonCol sizeSm='12' sizeMd='12' sizeLg='4' sizeXl='4'>
                <IonTitle>{texto}</IonTitle>
              </IonCol>
              <IonCol sizeSm='12' sizeMd='12' sizeLg='12' sizeXl='8'>
                {children
                  ? <IonItem lines="none">{children}</IonItem>
                  : <></>
                }
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonItem>
      </IonToolbar>
    </IonHeader>
  )
}
